import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { message } from 'antd'
import { axiosInstance } from '../../../hooks/useAxios'
import { updateChatRoomsAssingToUser } from '../../../../store/reducers/facebook/facebook-chat.slice'
import { ERRORS_MESSAGE_MAPPER } from '../../../constants/errors'
import {
  Box,
  Button,
  MenuItem,
  Popover,
  TextField,
  Typography,
} from '@mui/material'
import UserSelectSearch from '../../../components/SelectSearch/UserSelectSearch'

interface ActorPopoverProps {
  id?: string
  ids?: string[]
  anchorEl: HTMLElement | null
  isOpen: boolean
  availableAssignUsers?: string[]
  onClose: () => void
  onAssignTo?: (assignTo: string) => void
  setAssignToUser?: React.Dispatch<React.SetStateAction<string | null>>
}

const ActorPopover = (props: ActorPopoverProps) => {
  const {
    id,
    ids,
    anchorEl,
    isOpen,
    onClose,
    setAssignToUser,
    availableAssignUsers,
  } = props
  const [username, setUsername] = useState<string>('')
  const dispatch = useDispatch()

  const handleOnSubmit = useCallback(async () => {
    if (!username || username === '0') {
      message.error('กรุณาเลือกผู้ดูแลแชท')
      return
    }
    try {
      const response = await axiosInstance.post(
        `/facebook/pages/chatrooms/assign`,
        {
          username,
          ids,
        },
      )
      //   const { data } = response
      setAssignToUser?.(username)
      //   dispatch(updateChatRoomsAssingToUser(data))
      message.success('กำหนดผู้ดูแลแชทสำเร็จ')
      onClose()
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
  }, [username])

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Box sx={{ width: 400, p: 2 }}>
        <Typography variant="h6" mb={1}>
          เลือกผู้ดูแลแชท
        </Typography>
        {availableAssignUsers ? (
          <>
            <TextField
              select
              label="เลือกผู้ดูแลแชท"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              fullWidth
            >
              <MenuItem value={'0'}>เลือกผู้ดูแลแชท</MenuItem>
              {availableAssignUsers.map((user) => (
                <MenuItem key={user} value={user}>
                  {user}
                </MenuItem>
              ))}
            </TextField>
          </>
        ) : (
          <UserSelectSearch
            label={'เลือกผู้ดูแลแชท'}
            onSelect={(e) => setUsername(e?.value.username)}
            name="user"
          />
        )}
        <Box display="flex" justifyContent="flex-end" p={2}>
          <Button variant="contained" onClick={handleOnSubmit}>
            บันทึก
          </Button>
        </Box>
      </Box>
    </Popover>
  )
}

export default ActorPopover
